<template>
  <q-btn
    icon="fa fa-pencil"
    :title="title"
    v-bind="$attrs"
    @click="openModal"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { PostSearch } from '@/type';
import openModal from '@/components/modal';
import EditSearchModal from './EditSearchModal.vue';

export default defineComponent({
  emits: ['edited'],
  props: {
    postSearchId: {
      type: Number,
      required: true,
    },
    title: {
      type: String,
      default: 'Edit Search',
    },
  },
  methods: {
    openModal() {
      const config = {
        parent: this,
        postSearchId: this.postSearchId,
        title: this.title,
      };
      openModal(EditSearchModal, config)
        .onOk((postSearch: PostSearch) => {
          this.$emit('edited', postSearch);
        });
    },
  },
});
</script>
